module.exports = __webpack_public_path__ + "img/tab-vehicle-row-side-toyota.bee75f46.png";